import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from '../queries/queryKeys';

const deleteFlatMeterAttachment = async ({ meterId, attachId }) => {
  const response = await request.delete(
    `/Meter/individual_meter/${meterId}/attachment/${attachId}`,
    {},
    'Не удалось удалить файл',
    'Error'
  );

  return response;
};

const useDeleteFlatMeterAttachment = () => {
  const queryClient = useQueryClient();

  const deleteMutation = useMutation(deleteFlatMeterAttachment, {
    onSuccess: (data, { meterId }) => {
      if (data !== 'Error') {
        queryClient.invalidateQueries(
          getQueryKeys.flatMetersAttachments(meterId)
        );
      }
    },
  });

  return {
    deleteAttachment: deleteMutation.mutateAsync,
    loading: deleteMutation.isLoading,
  };
};

export default useDeleteFlatMeterAttachment;
